import React, { useContext } from 'react';
import { ReactElement } from 'react';
import { ViewStyle } from 'react-native';
import { Circle, G, Path, Polygon, Rect, Svg } from 'react-native-svg';
import { ThemeContext } from 'styled-components/native';

import { IconStyles } from 'components/icons/types';
import { useTransformContentStyle } from 'components/ResponsiveLayout';
import { sleepioColors } from 'config/getThemeForProducts/themes/sleepio';

const useGetSvgDimensions = (width: number, height: number) => {
  const transformStyle = useTransformContentStyle();
  const tW = transformStyle(width);
  const tH = transformStyle(height);
  return {
    width: tW,
    height: tH,
    viewBox: `0 0 ${width} ${height}`,
  };
};

type IconProps = {
  testID?: string;
};

type SVGProps = {
  width: number | string;
  height: number | string;
  scale?: number;
  viewBox: string;
  testID?: string;
};

const DuringDayIcon = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(35, 35);
  return (
    <Svg {...props} {...dimensionProps} disabled>
      <G transform="translate(-198.000000, -197.000000)" fill="#001948">
        <Path d="M215.589169,223.793103 C215.868534,223.793103 216.095004,223.985226 216.095004,224.222222 L216.095004,224.222222 L216.095004,231.570881 L216.090386,231.62911 C216.056891,231.838563 215.845254,232 215.589169,232 C215.309805,232 215.083335,231.807877 215.083335,231.570881 L215.083335,231.570881 L215.083335,224.222222 L215.087953,224.163993 C215.121448,223.95454 215.333085,223.793103 215.589169,223.793103 Z M222.289693,220.95414 C222.452973,220.787139 222.716789,220.788079 222.878943,220.95624 L222.878943,220.95624 L226.628924,224.845129 L226.669105,224.893401 C226.78957,225.061824 226.775321,225.300172 226.626885,225.45199 C226.463606,225.618991 226.19979,225.618051 226.037636,225.449891 L226.037636,225.449891 L222.287654,221.561002 L222.247473,221.512729 C222.127009,221.344307 222.141257,221.105958 222.289693,220.95414 Z M208.710307,220.95414 C208.858743,221.105958 208.872991,221.344307 208.752527,221.512729 L208.712346,221.561002 L204.962364,225.449891 C204.80021,225.618051 204.536394,225.618991 204.373115,225.45199 C204.224679,225.300172 204.21043,225.061824 204.330895,224.893401 L204.371076,224.845129 L208.121057,220.95624 C208.283211,220.788079 208.547027,220.787139 208.710307,220.95414 Z M215.5,207.754789 C218.951763,207.754789 221.749969,210.636635 221.749969,214.191571 C221.749969,217.746507 218.951763,220.628352 215.5,220.628352 C212.048237,220.628352 209.250031,217.746507 209.250031,214.191571 C209.250031,210.636635 212.048237,207.754789 215.5,207.754789 Z M232.574788,213.762541 C232.804858,213.757728 232.995155,213.945909 232.999916,214.182856 C233.004112,214.400058 232.850933,214.58284 232.648161,214.615502 L232.591711,214.620601 L224.258419,214.794931 C224.028349,214.799744 223.838052,214.611562 223.833291,214.374615 C223.829094,214.157414 223.982273,213.974632 224.185045,213.941969 L224.241495,213.93687 L232.574788,213.762541 Z M198.425212,213.762541 L206.758505,213.93687 L206.814955,213.941969 C207.017727,213.974632 207.170906,214.157414 207.166709,214.374615 C207.161948,214.611562 206.971651,214.799744 206.741581,214.794931 L206.741581,214.794931 L198.408289,214.620601 L198.351839,214.615502 C198.149067,214.58284 197.995888,214.400058 198.000084,214.182856 C198.004845,213.945909 198.195142,213.757728 198.425212,213.762541 L198.425212,213.762541 Z M226.626885,203.574829 C226.775321,203.726648 226.78957,203.964996 226.669105,204.133419 L226.628924,204.181691 L222.878943,208.07058 C222.716789,208.23874 222.452973,208.239681 222.289693,208.07268 C222.141257,207.920862 222.127009,207.682513 222.247473,207.514091 L222.287654,207.465818 L226.037636,203.576929 C226.19979,203.408769 226.463606,203.407829 226.626885,203.574829 Z M204.373115,203.574829 C204.536394,203.407829 204.80021,203.408769 204.962364,203.576929 L204.962364,203.576929 L208.712346,207.465818 L208.752527,207.514091 C208.872991,207.682513 208.858743,207.920862 208.710307,208.07268 C208.547027,208.239681 208.283211,208.23874 208.121057,208.07058 L208.121057,208.07058 L204.371076,204.181691 L204.330895,204.133419 C204.21043,203.964996 204.224679,203.726648 204.373115,203.574829 Z M215.589169,197 C215.845254,197 216.056891,197.161437 216.090386,197.37089 L216.095004,197.429119 L216.095004,204.777778 C216.095004,205.014774 215.868534,205.206897 215.589169,205.206897 C215.333085,205.206897 215.121448,205.04546 215.087953,204.836007 L215.083335,204.777778 L215.083335,197.429119 C215.083335,197.192123 215.309805,197 215.589169,197 Z" />
      </G>
    </Svg>
  );
};

const CantSleepIcon = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(30, 30);
  const theme = useContext(ThemeContext);
  return (
    <Svg {...props} {...dimensionProps}>
      <G
        transform="translate(-201.000000, -517.000000)"
        fill={theme.color.overlay.primary}
      >
        <Path d="M216,517 C224.284271,517 231,523.715729 231,532 C231,540.284271 224.284271,547 216,547 C207.715729,547 201,540.284271 201,532 C201,523.715729 207.715729,517 216,517 Z M217.191388,539.556706 L213.77512,539.556706 L213.77512,543.052632 L217.191388,543.052632 L217.191388,539.556706 Z M215.727273,523.315789 C213.028708,523.315789 210.473684,524.994935 210.473684,527.77516 C210.473684,528.215591 210.5311,528.656023 210.645933,529.096455 L213.401914,529.096455 C213.344498,528.903766 213.344498,528.68355 213.344498,528.490861 C213.344498,527.004404 214.320574,526.151068 215.842105,526.151068 C217.105263,526.151068 218.196172,526.94935 218.196172,528.215591 C218.196172,530.362695 214.148325,532.262057 213.746411,534.822066 C213.688995,535.152389 213.660287,535.455186 213.660287,535.78551 C213.660287,536.391103 213.91866,537.271967 214.23445,537.822506 L216.473684,537.822506 C216.38756,537.354547 216.330144,536.804008 216.330144,536.336049 C216.330144,533.445717 221.526316,532.454746 221.526316,528.325699 C221.526316,525.160097 218.827751,523.315789 215.727273,523.315789 Z" />
      </G>
    </Svg>
  );
};

const InBedIcon = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(21, 25);
  const theme = useContext(ThemeContext);
  return (
    <Svg {...props} {...dimensionProps}>
      <G
        transform="translate(-207.000000, -413.000000)"
        fill={theme.color.overlay.primary}
      >
        <Path d="M215.182141,421.794292 C215.182141,428.701183 220.677045,434.300325 227.455352,434.300325 C227.637859,434.300325 227.819436,434.296266 228,434.288231 C225.775086,436.579896 222.686906,438.000027 219.273211,438.000027 C212.494904,438.000027 207,432.400885 207,425.493993 C207,418.772386 212.204046,413.289306 218.730559,412.999965 C216.536448,415.258708 215.182141,418.365342 215.182141,421.794292 Z" />
      </G>
    </Svg>
  );
};

const RisingTimeIcon = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(35, 20);
  return (
    <Svg {...props} {...dimensionProps}>
      <G transform="translate(-198.000000, -93.000000)" fill="#001948">
        <Path d="M215.240625,104.904036 C218.519449,104.904036 221.177461,108.105891 221.177461,112.055579 L221.177,112.046 L232.231908,112.046557 L232.28553,112.052223 C232.478143,112.088512 232.623647,112.291591 232.619731,112.532911 C232.615138,112.796169 232.434376,113.005247 232.215832,112.9999 L232.215832,112.9999 L198.387753,112.9999 L198.334131,112.994234 C198.141518,112.957945 197.996014,112.754866 198.000083,112.513546 C198.004522,112.250288 198.185285,112.04121 198.403828,112.046557 L198.403828,112.046557 L209.303795,112.046524 C209.307853,108.100998 211.964308,104.904036 215.240625,104.904036 Z M225.19255,100.30492 C225.333549,100.473597 225.347084,100.738413 225.232655,100.925537 L225.194487,100.97917 L221.632386,105.299894 C221.478356,105.486727 221.227758,105.487772 221.072659,105.302227 C220.93166,105.13355 220.918125,104.868735 221.032554,104.68161 L221.070722,104.627977 L224.632823,100.307253 C224.786853,100.12042 225.037451,100.119376 225.19255,100.30492 Z M204.053731,100.30492 C204.20883,100.119376 204.459428,100.12042 204.613458,100.307253 L204.613458,100.307253 L208.175559,104.627977 L208.213727,104.68161 C208.328156,104.868735 208.314621,105.13355 208.173622,105.302227 C208.018523,105.487772 207.767925,105.486727 207.613895,105.299894 L207.613895,105.299894 L204.051794,100.97917 L204.013626,100.925537 C203.899197,100.738413 203.912732,100.473597 204.053731,100.30492 Z M214.707514,93 C214.950602,93 215.151499,93.1793632 215.183293,93.4120747 L215.187677,93.4767695 L215.187677,101.641448 C215.187677,101.904761 214.972701,102.118218 214.707514,102.118218 C214.464427,102.118218 214.26353,101.938854 214.231735,101.706143 L214.227351,101.641448 L214.227351,93.4767695 C214.227351,93.213457 214.442328,93 214.707514,93 Z" />
      </G>
    </Svg>
  );
};

const WindowDownIcon = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(35, 20);
  return (
    <Svg {...props} {...dimensionProps}>
      <G transform="translate(-198.000000, -310.000000)" fill="#001948">
        <Path d="M215.240625,321.904036 C218.519449,321.904036 221.177461,325.105891 221.177461,329.055579 L221.177,329.046 L232.231908,329.046557 L232.28553,329.052223 C232.478143,329.088512 232.623647,329.291591 232.619731,329.532911 C232.615138,329.796169 232.434376,330.005247 232.215832,329.9999 L232.215832,329.9999 L198.387753,329.9999 L198.334131,329.994234 C198.141518,329.957945 197.996014,329.754866 198.000083,329.513546 C198.004522,329.250288 198.185285,329.04121 198.403828,329.046557 L198.403828,329.046557 L209.303795,329.046524 C209.307853,325.100998 211.964308,321.904036 215.240625,321.904036 Z M225.19255,317.30492 C225.333549,317.473597 225.347084,317.738413 225.232655,317.925537 L225.194487,317.97917 L221.632386,322.299894 C221.478356,322.486727 221.227758,322.487772 221.072659,322.302227 C220.93166,322.13355 220.918125,321.868735 221.032554,321.68161 L221.070722,321.627977 L224.632823,317.307253 C224.786853,317.12042 225.037451,317.119376 225.19255,317.30492 Z M204.053731,317.30492 C204.20883,317.119376 204.459428,317.12042 204.613458,317.307253 L204.613458,317.307253 L208.175559,321.627977 L208.213727,321.68161 C208.328156,321.868735 208.314621,322.13355 208.173622,322.302227 C208.018523,322.487772 207.767925,322.486727 207.613895,322.299894 L207.613895,322.299894 L204.051794,317.97917 L204.013626,317.925537 C203.899197,317.738413 203.912732,317.473597 204.053731,317.30492 Z M214.707514,310 C214.950602,310 215.151499,310.179363 215.183293,310.412075 L215.187677,310.47677 L215.187677,318.641448 C215.187677,318.904761 214.972701,319.118218 214.707514,319.118218 C214.464427,319.118218 214.26353,318.938854 214.231735,318.706143 L214.227351,318.641448 L214.227351,310.47677 C214.227351,310.213457 214.442328,310 214.707514,310 Z" />
      </G>
    </Svg>
  );
};

const DownloadIcon = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(60, 72);
  return (
    <Svg {...props} {...dimensionProps}>
      <G fill="none">
        <Rect
          width="60"
          height="72"
          fill="#DDEFFF"
          rx="8"
          transform="matrix(1 0 0 -1 0 72)"
        />
        <Path
          fill="#036"
          d="M39 45v2H21v-2h18zm-8-20v12.2l5.6-5.6L38 33l-8 8-8-8 1.4-1.4 5.6 5.6V25h2z"
        />
      </G>
    </Svg>
  );
};

// Cta Circle Lock
export const CtaCircleLockSvg = (props: SVGProps): ReactElement => (
  <Svg {...props}>
    <G transform="translate(-1067 -2648) translate(978 2372) translate(89 276)">
      <Rect width="80" height="80" fill="#205D71" rx="40" />
      <Path
        fill="#FFF"
        fillRule="nonzero"
        d="M40.182 24c4.4 0 7.968 3.523 7.968 7.869l.001 6.384c1.253.195 2.213 1.28 2.213 2.587v12.542c0 1.446-1.173 2.618-2.619 2.618H32.618C31.172 56 30 54.828 30 53.382V40.84c0-1.308.96-2.392 2.213-2.587V31.87c0-4.346 3.568-7.869 7.969-7.869zm0 2.623c-2.934 0-5.312 2.349-5.312 5.246l-.001 6.353h10.625v-6.353c0-2.897-2.378-5.246-5.312-5.246z"
      />
    </G>
  </Svg>
);

export const CtaCircleLock = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(80, 80);
  return <CtaCircleLockSvg {...props} {...dimensionProps} />;
};

// Cta Circle Play
export const CtaCirclePlaySvg = (props: SVGProps): ReactElement => (
  <Svg {...props}>
    <G transform="translate(-1067 -2537) translate(978 2372) translate(89 165)">
      <Circle cx={21} cy={21.5} r={21} fill={'#163258'} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.323 21.27a.81.81 0 010 1.21l-8.474 7.565a.81.81 0 01-1.349-.604V14.309a.81.81 0 011.35-.604l8.473 7.566z"
        fill="#fff"
      />
    </G>
  </Svg>
);

export const CtaCirclePlay = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(80, 80);
  return <CtaCirclePlaySvg {...props} {...dimensionProps} />;
};

// Cta Circle Locked Play
export const CtaCircleLockedPlaySvg = (props: SVGProps): ReactElement => (
  <Svg {...props}>
    <G transform="translate(-1067 -2537) translate(978 2372) translate(89 165)">
      <Circle cx={21} cy={21.5} r={21} fill={'#B9C1CD'} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.323 21.27a.81.81 0 010 1.21l-8.474 7.565a.81.81 0 01-1.349-.604V14.309a.81.81 0 011.35-.604l8.473 7.566z"
        fill="#fff"
      />
    </G>
  </Svg>
);

export const CtaCircleLockedPlay = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(80, 80);
  return <CtaCircleLockedPlaySvg {...props} {...dimensionProps} />;
};

// Cta Circle Replay
export const CtaCircleReplaySvg = (props: SVGProps): ReactElement => (
  <Svg {...props}>
    <G transform="translate(-1067 -2426) translate(978 2372) translate(89 54)">
      <Rect y={0.5} width={42} height={42} rx={21} fill="#4A78B6" />
      <Path
        d="M21.167 15.09V11.5l-5.313 5.128 5.313 5.128v-4.615c3.52 0 6.375 2.755 6.375 6.154s-2.854 6.154-6.375 6.154-6.375-2.755-6.375-6.154h-2.125c0 4.531 3.806 8.205 8.5 8.205s8.5-3.674 8.5-8.205c0-4.531-3.806-8.205-8.5-8.205z"
        fill="#fff"
      />
    </G>
  </Svg>
);

export const CtaCircleReplay = (props: IconProps): ReactElement => {
  const dimensionProps = useGetSvgDimensions(80, 80);
  return <CtaCircleReplaySvg {...props} {...dimensionProps} />;
};

export const PadLockSvg = (
  props: Partial<SVGProps & { fill: string; style: ViewStyle }>
): ReactElement => {
  const theme = useContext(ThemeContext);
  return (
    <Svg
      width={props?.width || '24'}
      height={props?.height || '34'}
      viewBox={props?.viewBox || '0 0 24 34'}
      fill="none"
      style={props?.style}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8298 15.111H20.9969C22.2492 15.111 23.2644 16.1262 23.2644 17.3785V31.7324C23.2644 32.9847 22.2492 33.9999 20.9969 33.9999H3.13374C1.88142 33.9999 0.866211 32.9847 0.866211 31.7324V17.3785C0.866211 16.1262 1.88142 15.111 3.13374 15.111H3.3008V8.36065C3.3008 3.74319 7.22481 0 12.0653 0C16.9058 0 20.8298 3.74319 20.8298 8.36065V15.111ZM17.9083 15.111V8.36065C17.9083 5.28235 15.2923 2.78689 12.0653 2.78689C8.83831 2.78689 6.22231 5.28235 6.22231 8.36065V15.111H17.9083Z"
        fill={props?.fill || theme.color.overlay.primary}
      />
    </Svg>
  );
};

export const CEMark = (): ReactElement => {
  const theme = useContext(ThemeContext);
  return (
    <Svg width="33" height="24" viewBox="0 0 33 24" fill="none">
      <Path
        opacity="0.9"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9277 23.76C5.34004 23.76 0 18.4413 0 11.88C0 5.31868 5.34004 0 11.9277 0C12.3575 0 12.7821 0.022572 13.2 0.066528V3.65983C12.7853 3.59647 12.3603 3.564 11.9277 3.564C7.31646 3.564 3.57831 7.28719 3.57831 11.88C3.57831 16.4728 7.31646 20.196 11.9277 20.196C12.3603 20.196 12.7853 20.1635 13.2 20.1002V23.6935C12.7821 23.7374 12.3575 23.76 11.9277 23.76ZM33 20.1117V23.7014C32.6052 23.7402 32.2052 23.76 31.8 23.76C25.1724 23.76 19.8 18.4413 19.8 11.88C19.8 5.31868 25.1724 0 31.8 0C32.2052 0 32.6052 0.0198 33 0.058608V3.64795C32.608 3.59251 32.2076 3.564 31.8 3.564C27.7784 3.564 24.4172 6.36134 23.5932 10.098H30.6V13.662H23.5932C24.4172 17.3987 27.7784 20.196 31.8 20.196C32.2076 20.196 32.608 20.1675 33 20.1117Z"
        fill={theme.color.overlay.primary}
      />
    </Svg>
  );
};

export const UKCAMark = ({
  color,
  size,
}: {
  color: string;
  size: number;
}): ReactElement => (
  <Svg width={size} height={size} viewBox="0 0 640 640" fill="none">
    <G fill-rule="evenodd" id="UKCA">
      <Path
        id="U"
        fill={color}
        d="M 80 80 V 230 A 70 70 0 0 0 150 300 H 230 A 70 70 0 0 0 300 230 V 80 H 250 V 230 A 20 20 0 0 1 230 250 H 150 A 20 20 0 0 1 130 230 V 80 Z"
      />
      <Path
        id="K"
        fill={color}
        d="M 340 80 V 300 H 390 V 220 L 490 300 H 560 L 420 190 560 80 H 490 L 390 160 V 80 Z"
      />
      <Path
        id="C"
        fill={color}
        d="M 300 340 V 390 H 150 A 20 20 0 0 0 130 410 V 490 A 20 20 0 0 0 150 510 H 300 V 560 H 150 A 70 70 0 0 1 80 490 V 410 A 70 70 0 0 1 150 340 Z"
      />
      <Path
        id="A"
        fill={color}
        d="M 340 560 V 410 A 70 70 0 0 1 410 340 H 490 A 70 70 0 0 1 560 410 V 560 H 510 V 510 H 390 V 560 Z M 390 460 H 510 V 410 A 20 20 0 0 0 490 390 H 410 A 20 20 0 0 0 390 410 Z"
      />
    </G>
  </Svg>
);

export const ChevronIconSvg = ({
  size = 33,
  style,
  isHovering,
}: {
  size?: number;
  style?: IconStyles;
  isHovering?: boolean;
}): React.ReactElement => {
  const svgStyle = Object.assign(
    {
      color: isHovering ? 'white' : undefined,
    },
    style
  );
  return (
    <Svg width={size} height={size} viewBox="0 0 40 40" style={svgStyle}>
      <Rect
        id="Rectangle"
        fill={style?.color || 'currentColor'}
        opacity="0"
        x="0"
        y="0"
        width="40"
        height="40"
        rx="8"
      />
      <Polygon
        fill={isHovering ? 'white' : style?.color || 'black'}
        points="24.6 16 20 20.6 15.4 16 14 17.4 20 23.4 26 17.4"
      />
    </Svg>
  );
};

export const BackIconSvg = (): React.ReactElement => {
  const theme = useContext(ThemeContext);
  return (
    <Svg width={32} height={32} viewBox="0 0 32 32" fill="none">
      <G>
        <Path
          d="M26.666 14.667H10.44l7.453-7.454L16 5.333 5.333 16 16 26.667l1.88-1.88-7.44-7.454h16.226v-2.666z"
          fill={theme.color.overlay.primary}
        />
      </G>
    </Svg>
  );
};

export const LeftArrow = (): React.ReactElement => {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <G>
        <Path
          d="M15.5 8H0.5"
          stroke="#163258"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M7.5 1L0.5 8L7.5 15"
          stroke="#163258"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </G>
    </Svg>
  );
};

export const MFACloseButtonSvg = (): React.ReactElement => {
  const theme = useContext(ThemeContext);
  return (
    <Svg width={32} height={32} viewBox="0 0 32 32">
      <G>
        <Path
          d="M25.334 8.547l-1.88-1.88L16 14.12 8.547 6.667l-1.88 1.88L14.12 16l-7.453 7.454 1.88 1.88L16 17.88l7.454 7.454 1.88-1.88L17.88 16l7.454-7.453z"
          fill={theme.color.overlay.primary}
        />
      </G>
    </Svg>
  );
};

export const CopyIcon = (): React.ReactElement => {
  const theme = useContext(ThemeContext);
  return (
    <Svg width={17} height={20} viewBox="0 0 17 20">
      <Path
        d="M12.3333 0.833374H2.33333C1.41667 0.833374 0.666668 1.58337 0.666668 2.50004V14.1667H2.33333V2.50004H12.3333V0.833374ZM14.8333 4.16671H5.66667C4.75 4.16671 4 4.91671 4 5.83337V17.5C4 18.4167 4.75 19.1667 5.66667 19.1667H14.8333C15.75 19.1667 16.5 18.4167 16.5 17.5V5.83337C16.5 4.91671 15.75 4.16671 14.8333 4.16671ZM14.8333 17.5H5.66667V5.83337H14.8333V17.5Z"
        fill={theme.color.overlay.primary}
      />
    </Svg>
  );
};

export const WarningIconSvg = (): React.ReactElement => {
  const dimensionProps = useGetSvgDimensions(22, 20);
  return (
    <Svg {...dimensionProps} fill="none">
      <Path
        d="M10.704 3.5a.342.342 0 01.592 0l7.621 13.168a.342.342 0 01-.296.514H3.38a.342.342 0 01-.296-.514l7.62-13.167zm1.48-2.818a1.368 1.368 0 00-2.368 0L.189 17.31a1.368 1.368 0 001.184 2.054h19.254a1.368 1.368 0 001.184-2.054L12.184.682zM12.091 15a1.09 1.09 0 10-2.182 0 1.09 1.09 0 002.182 0zm0-6.952a.684.684 0 00-.684-.684h-.814a.684.684 0 00-.684.684v3.813c0 .378.306.684.684.684h.814a.684.684 0 00.684-.684V8.048z"
        fill={sleepioColors.warningBorderColor}
      />
    </Svg>
  );
};

export const iconsDictionary = {
  padlock: PadLockSvg,
  chevron: ChevronIconSvg,
  warning: WarningIconSvg,
  'rising-time': RisingTimeIcon,
  'during-the-day': DuringDayIcon,
  'winding-down': WindowDownIcon,
  'in-bed': InBedIcon,
  'if-you-cant-sleep': CantSleepIcon,
  'download-icon': DownloadIcon,
  'cta-circle-lock': CtaCircleLockedPlay,
  'cta-circle-play': CtaCirclePlay,
  'cta-circle-replay': CtaCircleReplay,
  'back-icon': BackIconSvg,
  'mfa-close-button': MFACloseButtonSvg,
  'copy-icon': CopyIcon,
};
